module.exports = __webpack_public_path__ + "static/media/BuncombeTurnpikeDitchDigginBluesCDpackageinside.b5f40249.webp";